import { useQuery } from '@tanstack/react-query';

import { bookingObjectsApi } from '@/shared/api/bookingObjects';
import { getMembers } from '@/shared/helpers/utils.ts';

export const PlaceLocation = ({ placeId, depth = -1 }: { placeId: number; depth?: number }) => {
	const { data: getPlaceParents } = useQuery({
		queryKey: ['placeParents', placeId],
		queryFn: () => bookingObjectsApi.getObjectParents(placeId),
	});
	if (!getPlaceParents) return null;

	return getMembers([getPlaceParents])
		.slice(0, depth)
		.map((place) => place.name)
		.join(' • ');
};
